import ScrollToTop from 'components/ScrollToTop/Scroll';
import React, { Fragment, useEffect, useState } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';

// Import custom components
import PrivateRoute from '../../routes/PrivateRoute';
import RestrictRoute from '../../routes/RestrictRoute';

import {
  AsyncLoginForm,
  AsyncOTPForm,
  AsyncResetForm,
  AsyncAppLayout,
  AsyncAppStaticLayout,
  AsyncInternalServer,
  AsyncNotFound,
  AsyncDashboard,
  AsyncForbidden,
  AsyncProfile,
  AsyncRole,
  AsyncUser,
  AsyncBranch,
  AsyncSwitch,
  AsyncSetting,
  AsyncDepartment,
  AsyncOperator,
  AsyncTerminal,
  AsyncCustomer,
  AsyncMTO,
  AsyncApp,
  AsyncTransaction,
  AsyncUtility,
  AsyncInquiry,
  AsyncChannel,
  AsyncCompliance,
  AsyncRequest,
  AsyncTransactionRule,
  AsyncActivityLog,
  AsyncAuditLog,
  AsyncEMITransaction,
  AsyncSettlement,
  AsyncNotification,
  AsyncUploadTransaction,
  AsyncQrReceipt,
  AsyncNewQrReceipt,
  AsyncQrProvider,
  AsyncSupport,
  AsyncMerchantAutoOnboard,
  AsyncBillingSystem,
} from './AsyncComponent';
import { OfflineComponent } from 'components/Common/Excception/OfflineComponent';
import MerchantAutoPushModule from 'containers/getpay/MerchantAutoPushModule';
import MerchantOnboardDetails from 'containers/getpay/MerchantOnboardDetails';
import MerchantAutoPushDetailModule from 'containers/getpay/MerchantAutoPushDetailModule';
import APP_CONFIG from 'constants/appConfig';

const App = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    document.title = APP_CONFIG.title;
    const favicon = document.getElementById('favicon');

    favicon.href = APP_CONFIG.favIcon;

    const handleOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    document.addEventListener('click', handleOnlineStatus);
    document.addEventListener('keydown', handleOnlineStatus);
    return () => {
      document.removeEventListener('click', handleOnlineStatus);
      document.removeEventListener('keydown', handleOnlineStatus);
    };
  }, []);

  return (
    <Fragment>
      {isOnline ? (
        <ScrollToTop>
          <Switch>
            <RestrictRoute
              exact
              path="/"
              layout={AsyncAppStaticLayout}
              component={AsyncLoginForm}
            />
            <RestrictRoute
              exact
              path="/otp"
              layout={AsyncAppStaticLayout}
              component={AsyncOTPForm}
            />
            <RestrictRoute path="/reset" layout={AsyncAppStaticLayout} component={AsyncResetForm} />

            <PrivateRoute path="/dashboard" layout={AsyncAppLayout} component={AsyncDashboard} />
            <PrivateRoute path="/settings/roles" layout={AsyncAppLayout} component={AsyncRole} />
            <PrivateRoute path="/settings/users" layout={AsyncAppLayout} component={AsyncUser} />
            <PrivateRoute
              path="/settings/departments"
              layout={AsyncAppLayout}
              component={AsyncDepartment}
            />
            <PrivateRoute
              path="/settings/branches"
              layout={AsyncAppLayout}
              component={AsyncBranch}
            />
            <PrivateRoute
              path="/settings/transactions-rules"
              layout={AsyncAppLayout}
              component={AsyncTransactionRule}
            />
            <PrivateRoute path="/switches" layout={AsyncAppLayout} component={AsyncSwitch} />
            <PrivateRoute path="/operators" layout={AsyncAppLayout} component={AsyncOperator} />
            <PrivateRoute path="/terminals" layout={AsyncAppLayout} component={AsyncTerminal} />
            <PrivateRoute path="/customers" layout={AsyncAppLayout} component={AsyncCustomer} />
            <PrivateRoute path="/mto" layout={AsyncAppLayout} component={AsyncMTO} />
            <PrivateRoute path="/apps" layout={AsyncAppLayout} component={AsyncApp} />
            <PrivateRoute
              path="/transactions/upload-transaction"
              layout={AsyncAppLayout}
              component={AsyncUploadTransaction}
            />
            <PrivateRoute
              path="/transactions"
              layout={AsyncAppLayout}
              component={AsyncTransaction}
            />
            <PrivateRoute
              path="/merchants"
              layout={AsyncAppLayout}
              component={AsyncMerchantAutoOnboard}
            />
            <PrivateRoute
              path="/emi-transactions"
              layout={AsyncAppLayout}
              component={AsyncEMITransaction}
            />

            <PrivateRoute path="/settlement" layout={AsyncAppLayout} component={AsyncSettlement} />
            <PrivateRoute path="/support" layout={AsyncAppLayout} component={AsyncSupport} />

            <PrivateRoute
              path="/settings/activity-logs"
              layout={AsyncAppLayout}
              component={AsyncActivityLog}
            />
            <PrivateRoute path="/audit-logs" layout={AsyncAppLayout} component={AsyncAuditLog} />
            <PrivateRoute path="/utilities" layout={AsyncAppLayout} component={AsyncUtility} />
            <PrivateRoute path="/inquiries" layout={AsyncAppLayout} component={AsyncInquiry} />
            <PrivateRoute path="/requests" layout={AsyncAppLayout} component={AsyncRequest} />
            <PrivateRoute path="/settings" layout={AsyncAppLayout} component={AsyncSetting} />
            <PrivateRoute path="/profile" layout={AsyncAppLayout} component={AsyncProfile} />
            <PrivateRoute path="/403" layout={AsyncAppLayout} component={AsyncForbidden} />
            <PrivateRoute path="/channels" layout={AsyncAppLayout} component={AsyncChannel} />
            <PrivateRoute
              path="/notifications"
              layout={AsyncAppLayout}
              component={AsyncNotification}
            />
            <PrivateRoute
              path="/qr-providers"
              layout={AsyncAppLayout}
              component={AsyncQrProvider}
            />
            <PrivateRoute path="/compliances" layout={AsyncAppLayout} component={AsyncCompliance} />
            <Route path="/receipt/:qrData" component={AsyncQrReceipt} />
            <Route path="/e-receipt/:token" component={AsyncNewQrReceipt} />
            <PrivateRoute
              path="/billing-system"
              layout={AsyncAppLayout}
              component={AsyncBillingSystem}
            />
            <Route path="/500" component={AsyncInternalServer} />
            <Route path="/404" component={AsyncNotFound} />
            <Route component={AsyncNotFound} />
          </Switch>
        </ScrollToTop>
      ) : (
        <OfflineComponent
          message={
            'Sorry, we are currently unable to process your request. This could be due to a network issue or a problem with the application. You can try reloading the page, and if the problem still persists, contact support.'
          }
        />
      )}
    </Fragment>
  );
};

export default withRouter(App);
